<div id="outer">
  <app-header bare="true"></app-header>
  <div id="inner">
    <div id="content">
      <p i18n>The requested page was not found.</p>
    </div>
  </div>
</div>
